import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PlayerProfileTabView from "../tabView/playerProfileTabView";
import "../../assets/css/scss/section/player/_profileTabSection.scss";

export default function ProfileTabSection(props: any) {
    return (
        <section className="profile-tab-main-section">
            <Container className="px-0">
                <Row className="no-gutters">
                    <Col>
                        <PlayerProfileTabView {...props} />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
